const UserCdKeyComponent = () => import('@/views/UserCdKey/UserCdKeyView')

export default [
    {
        path:'/UserCdKeyIndex',
        name:'UserCdKeyRouter',
        component:UserCdKeyComponent
    }
]